import React, { useState } from "react";
import axios from "axios";

const DeletePppSecretModal = ({
  isOpen,
  onClose,
  row,
  usermanId,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen || !row) return null;

  const handleDelete = async () => {
    try {
      setLoading(true);
      setError("");

      await axios.delete("https://api.wifikamu.my.id/ppp-secret/delete", {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        data: {
          userman_id: usermanId,
          ppp_secret_id: row.id,
        },
      });

      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to delete PPP Secret");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-lg bg-white dark:bg-slate-900 shadow-lg">
        <div className="flex items-center justify-between px-4 py-3 border-b dark:border-slate-700">
          <h2 className="font-semibold">Delete PPP Secret</h2>

          <button onClick={onClose}>✕</button>
        </div>

        <div className="p-4 space-y-3">
          <div className="rounded-lg bg-red-50 dark:bg-red-950/30 p-3">
            <p className="text-red-600 dark:text-red-400 text-sm">
              This action cannot be undone.
            </p>
          </div>

          <div>
            <p className="text-sm text-slate-500">PPP Secret</p>

            <p className="font-medium">{row.name}</p>
          </div>

          <div>
            <p className="text-sm text-slate-500">Profile</p>

            <p>{row.profile || "-"}</p>
          </div>

          <div>
            <p className="text-sm text-slate-500">Customer ID</p>

            <p>{row.customer_id || "-"}</p>
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>

        <div className="flex justify-end gap-2 px-4 py-3 border-t dark:border-slate-700">
          <button
            onClick={onClose}
            className="px-3 py-2 rounded border dark:border-slate-700"
          >
            Cancel
          </button>

          <button
            onClick={handleDelete}
            disabled={loading}
            className="px-3 py-2 rounded bg-red-600 text-white hover:bg-red-700"
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePppSecretModal;
